import React, { useState } from "react";
import BgCheckOut from "../../images/bgcheckOut.png";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import BackButton from "../bars/BackButton";

function CheckOut() {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [roomNo, setRoomNo] = useState("");
  const [comment, setComment] = useState("");
  const reservationId = localStorage.getItem("reservationId");
  const [loading, setLoading] = useState(false);

  const handleRoomNo = (e) => {
    setRoomNo(e.target.value);
    setError("");
  };

  const handleComment = (e) => {
    setComment(e.target.value);
    setError("");
  };

  const checkOutReq = async () => {
    var data = {
      reservationId,
    };
    setLoading(true);
    try {
      await axios({
        method: "post",
        url: `${baseURL}/api/preCheckoutV21`,
        data: data,
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        setLoading(false);
        if (response) {
          setSuccess(true);
        }
      });
    } catch (error) {
      setLoading(false);
      setError("Some thing went wrong..");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (roomNo !== "" && comment !== "") {
      checkOutReq();
    } else {
      setError("please give datas");
    }
  };

  return (
    <div>
      <div className="mb-28 relative">
        <img
          className="w-screen sm:h-[230px] h-[117px]"
          src={BgCheckOut}
          alt="bgHotelguide"
        />
        <div className="absolute top-3 left-3">
          <BackButton />
        </div>
        <div className="section-wrap mx-4 mt-6 sm:mt-14">
          <div className="guestName sm:text-center text-left">Check-out</div>
          <form className="flex flex-col">
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Your Room Number
            </label>
            <input
              onChange={handleRoomNo}
              value={roomNo}
              className="mt-2 reqInput"
              type="text"
            />
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Comment if any
            </label>
            <textarea
              value={comment}
              onChange={handleComment}
              className="mt-2 reqInput"
              type="textarea" 
            />
            <button
              disabled={loading}
              onClick={handleSubmit}
              className="bookBtn mt-10 max-w-[400px] relative"
            >
              Request Check-out
              {loading && <ButtonLoader />}
            </button>
          </form>
        </div>
        <div className="mt-10 fixed  bottom-5 left-1/2 -translate-x-1/2">
          {error && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">{error}</div>
            </div>
          )}
          {error == "axios" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Somthing went wrong..
              </div>
            </div>
          )}
          {success && (
            <div className="w-full flex justify-center">
              <div className="success-doc text-center mt-3">
                Successfully Requested
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CheckOut;
